module.exports = __webpack_public_path__ + "static/index/img/baikal-201.dfccc646.jpg";